import {refreshWindSensorsData} from "./data";
import {refreshTimeline} from "./timeline";

let refreshing = false;

document.addEventListener('visibilitychange', function() {
  console.debug('visibilitychange - visibilityState: ' + document.visibilityState);
  if (document.visibilityState === 'visible') {
    refreshStaleTimeline();
  }
});

window.addEventListener('focus', function() {
  console.debug('window focus');
  refreshStaleTimeline();
});

function refreshStaleTimeline() {
  if (refreshing) {
    return;
  }
  refreshing = true;
  try {
    if (typeof wm !== 'undefined' && !wm.isEditMode()) {
      const lastObs = Array.from(document.querySelectorAll("#timeline_steps .tl_item.tl_obs")).pop(),
        now = new Date().getTime() / 1000;
      if (lastObs) {
        if (now - parseInt(lastObs.getAttribute('data-ts')) < 3600) {
          refreshWindSensorsData();
          setTimeout(refreshTimeline, 1000);
        } else {
          window.location.reload();
        }
      }
    }
  } finally {
    setTimeout(() => {
      refreshing = false;
    }, 1000);
  }
}
